export const OBTENER_LISTADO_DETALLE_COMISIONES =
    'OBTENER_LISTADO_DETALLE_COMISIONES';
export const SELECCIONAR_PAGINA_DETALLE_COMISION =
    'SELECCIONAR_PAGINA_DETALLE_COMISION';
export const TOTAL_DETALLE_COMISION = 'TOTAL_DETALLE_COMISION';
